import React from 'react';
import { connect } from 'react-redux';
import './style.scoped.scss';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';

const AboutTheDocument = ({ currentDocument, handlePreviousVersion, documents }) => {

  const defineNewDocSlug = (id) => {
    if (documents && documents.length > 0) {
      const newDocument = documents.filter((doc) => doc.id === id)[0];
      if (newDocument) {
        return newDocument.slug;
      } else {
        return id;
      }
    } else return id;
  };

  return (
    <div className="dates-wrapper">
      <b className="text-left w-100">
        {currentDocument.title}
      </b>
      {currentDocument.versionDate ? (
        <p>
          <b>Version Date:</b>
          <span>
            {currentDocument.versionDate.toLocaleDateString()}
          </span>
        </p>
      ) : null}
      {currentDocument.registrationDate ? (
        <p>
          <b>Registration Date:</b>
          <span>
            {currentDocument.registrationDate.toLocaleDateString()}
          </span>
        </p>
      ) : null}
      {currentDocument.status === 'Superseded' ? (
        <Link
          className="previous-versions superseded"
          to={ROUTES.DOCUMENT(defineNewDocSlug(currentDocument.newVersionId))}
          target="_blank"
          rel="noreferrer"
        >
          This document has been superseded.<br />Click here to see the new version.
        </Link>
      ) : (
        currentDocument.previousVersionsList && currentDocument.previousVersionsList.length > 0 && (
          <b className="previous-versions w-100" onClick={() => handlePreviousVersion(currentDocument.previousVersionsList[0])}>
            Previous Version
          </b>
        )
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentDocument: state.document.currentDocument,
  documents: state.client.documents,
});

const connector = connect(mapStateToProps, null);

export default connector(AboutTheDocument);
